// extracted by mini-css-extract-plugin
module.exports = {"disclosureDetail":"DisclosureDetail_disclosureDetail__Yc21l","tabCardContainer":"DisclosureDetail_tabCardContainer__2S4IM","divider":"DisclosureDetail_divider__1WMku"};